<app-breadcrumb [title]="'Personas Inactivas'" [items]="['Personas', 'Listados']" [active_item]="'Inactivos'"></app-breadcrumb>
<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-ui-block me-2"></i>
      <h5 class="mb-0"><strong>LISTADO DE PERSONAS INACTIVAS</strong></h5>
    </div>
    <div class="card-body custom-datatable noscroll">
     <div class="row mb-12">
      <div class="col-sm-12 col-md-3 ms-auto"> 
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar....."
            [(ngModel)]="searchText"
            (input)="filterData()"
          />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>

      <!-- Skeleton loader -->
      <div *ngIf="loading" class="custom-datatable table-responsive mt-4">
        <table class="table table-hover table-bordered">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><div class="skeleton skeleton-text" style="width: 60px; margin: 0 auto;"></div></th>
              <th class="text-center"><div class="skeleton skeleton-text" style="width: 100px; margin: 0 auto;"></div></th>
              <th class="text-center"><div class="skeleton skeleton-text" style="width: 150px; margin: 0 auto;"></div></th>
              <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
              <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
              <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
              <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
              <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of [1,2,3,4,5,6,7,8]">
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text"></div></td>
              <td><div class="skeleton skeleton-text" style="width: 30px; margin: 0 auto;"></div></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="!loading" class="custom-datatable table-responsive mt-4">
        
       <table class="table table-hover table-bordered" id="tblProInactivo">
          <thead class="bg-primary">
            <tr>
            <th class="text-center" style="cursor: pointer" (click)="sortData('tipo')">
              <strong>TIPO</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'tipo' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'tipo' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'tipo'
              }"></i>
            </th>
            
            <th class="text-center" style="cursor: pointer" (click)="sortData('cedula')">
              <strong>DOCUMENTO</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'cedula' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'cedula' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'cedula'
              }"></i>
            </th>
            
            <th class="text-center" style="cursor: pointer" (click)="sortData('primernombre')">
              <strong>NOMBRES Y APELLIDOS</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'primernombre' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'primernombre' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'primernombre'
              }"></i>
            </th>
            
            <th class="text-center" style="cursor: pointer" (click)="sortData('condicionLaboral.label')">
              <strong>RELACIÓN</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'condicionLaboral.label' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'condicionLaboral.label' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'condicionLaboral.label'
              }"></i>
            </th>
            
            <th class="text-center" style="cursor: pointer" (click)="sortData('cargoData.cargos')">
              <strong>CARGO</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'cargoData.cargos' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'cargoData.cargos' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'cargoData.cargos'
              }"></i>
            </th>
            
            <th class="text-center" style="cursor: pointer" (click)="sortData('telcel')">
              <strong>CELULAR</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'telcel' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'telcel' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'telcel'
              }"></i>
            </th>
            
            <th class="text-center" style="cursor: pointer" (click)="sortData('mail')">
              <strong>EMAIL</strong>
              <i class="fa" [ngClass]="{
                'fa-sort-up': sortColumn === 'mail' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'mail' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'mail'
              }"></i>
            </th>

              <th class="text-center"><strong>ACCIONES</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let propietario of filteredTableItems| paginate: { itemsPerPage: pageSize, currentPage: page }; let i = index">
              <td class="text-center">{{ propietario.tipo }}</td>
              <td class="text-center">{{ propietario.cedula }}</td>
              <td class="text-uppercase text-justify">
                {{ propietario.primernombre }} {{ propietario.segundonombre }} {{ propietario.papellidos }} {{ propietario.seapellidos }}
              </td>
              <td class="text-center">{{ propietario.condicionLaboral.label }}</td>
              <td class="text-center">{{ propietario.cargoData.cargos }}</td>
              <td class="text-center">{{ propietario.telcel }}</td>
              <td class="text-center">{{ propietario.mail }}</td>
             <td class="text-center align-middle">
              
              <div class="action text-center">
                  <ul class="list-inline">
                    <li class="">
                      <a href="javascript:void(0)"><i class="icon-check-box" (click)="avisoActivarPersona(propietario.cedula)" ngbTooltip="Activar Persona"></i></a>
                    </li>
              
                <!-- Botón Activar -->
               
              </ul>
              </div>
            </td>
            </tr>
          </tbody>
        </table>
        
        <div class="d-flex justify-content-between align-items-center mt-4">
          <!-- Selector de registros por página alineado a la izquierda -->
          <div class="d-flex align-items-center">
            <label for="pageSize" class="me-2">Mostrar:</label>
            <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50,100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>
        
           <!-- Mostrar cantidad total de registros centrado -->
        <div class="text-center flex-grow-1">
          Tota Registros:        
          <a class="badge badge-primary"><b>{{ filteredTableItems.length }}</b></a>
        </div>

          <!-- Paginador alineado a la derecha -->
          <div class="text-end paginador-personalizado">
            <pagination-controls 
              (pageChange)="page = $event" 
              [maxSize]="5"
              
              [directionLinks]="true"
              [autoHide]="true"
              previousLabel="Anterior" 
              nextLabel="Siguiente">
            </pagination-controls>
          </div>
        </div>
        
        
        
        
    
      
    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" 
        ngbTooltip="Exportar a Excel" (click)="exportarExcel('tblProActivo','Listado_activos')">
    <i class="icofont icofont-file-excel"></i> EXCEL
</button>

      <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="exportToPDF('tblProActivo','Listado_activos','Listado de Personas Activas')">
        <i class="icofont icofont-file-pdf"></i> PDF
     </button>

     
        
      </div>
    </div>
    
  </div>
</div>

